<template>
  <ModalLayout>
    <template #header>{{ $t(`${modalType}.TITLE`) }}</template>
    <template #body>
      <div class="c-change-modal">
        <div class="c-change-modal__name" contenteditable="true" @input="onChange">{{ modelValue }}</div>
        <div class="c-change-modal__buttons">
          <button class="btn btn-cancel-outline c-change-modal__button" @click.prevent="onClose">
            {{ $t(`${modalType}.CLOSE`) }}
          </button>
          <button
            :disabled="!wasEdited"
            :class="['btn btn-secondary c-change-modal__button', wasEdited ? 'c-change-modal__button--active' : '']"
            @click.prevent="onSave"
          >
            {{ $t(`${modalType}.OK`) }}
          </button>
        </div>
      </div>
    </template>
  </ModalLayout>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import ModalLayout from '@/components/layout/modal/ModalLayout.vue';
import useModal from '@/services/useModal';

interface ChangeModalProps {
  modelValue: string;
  rename?: boolean;
}

const props = withDefaults(defineProps<ChangeModalProps>(), {
  rename: true,
});

const emit = defineEmits<{
  'update:modelValue': [value: string];
  save: [];
  saveAs: [];
}>();

const { close } = useModal();
const wasEdited = ref<boolean>(false);
const modelValueBeforeChanges = props.modelValue;

const modalType = computed(() => (props.rename ? 'RENAME_MODAL' : 'SAVE_AS_MODAL'));

const onSave = () => {
  if (props.rename) {
    emit('save');
  } else {
    emit('saveAs');
  }
  close();
};

const onChange = (event) => {
  if (!wasEdited.value) {
    wasEdited.value = true;
  }

  emit('update:modelValue', event.target.innerText);
};

const onClose = () => {
  emit('update:modelValue', modelValueBeforeChanges);
  close();
};
</script>
